import { useWSMutation, useWSQuery } from "../../../query/helpers";
import { WSServiceError } from "../../../utils/serviceHelper";
import { oauthService } from "../services/oauthService";
import {
  IOAuthAuthorizeParams,
  IOAuthAuthorizeResponse,
  IOAuthAuthorizeSubmit,
  IOAuthRedirectResponse
} from "../types";

export const QUERY_OAUTH_AUTHORIZE = "QUERY_OAUTH_AUTHORIZE";

/**
 * Hook to fetch OAuth authorization details
 */
export const useQueryOAuthAuthorize = (params: IOAuthAuthorizeParams) => {
  return useWSQuery<IOAuthAuthorizeResponse, WSServiceError>(
    [QUERY_OAUTH_AUTHORIZE, params],
    () => oauthService.getAuthorizeDetails(params),
    {
      enabled: !!params.client_id && !!params.redirect_uri,
      staleTime: 5 * 60 * 1000, // 5 minutes
      cacheTime: 10 * 60 * 1000, // 10 minutes - Note: Using cacheTime (React Query v4), not gcTime (v5)
      retry: 1
    }
  );
};

/**
 * Hook to submit OAuth authorization decision
 */
export const useMutationOAuthAuthorize = () => {
  return useWSMutation<
    IOAuthRedirectResponse,
    WSServiceError,
    IOAuthAuthorizeSubmit
  >(
    (params: IOAuthAuthorizeSubmit) => oauthService.submitAuthorization(params),
    {
      onSuccess: data => {
        // Redirect to the URI returned from the backend
        if (data.redirect_uri) {
          window.location.href = data.redirect_uri;
        }
      }
    }
  );
};
